import { u as n, $ as t, L as o, h as l, s as r, e as d } from "./main-zRUwk2ge.mjs";
var h = "dx-export-loadpanel";
class m {
  constructor(e, a, s, i) {
    this._$targetElement = a, this._$container = s, this._loadPanel = e._createComponent(t("<div>").addClass(h).appendTo(this._$container), o, this.getOptions(i));
  }
  getDefaultOptions() {
    return {
      animation: null,
      shading: !1,
      height: 90,
      width: 200,
      container: this._$container
    };
  }
  getOptions(e) {
    return l(e.text) ? e.message = e.text : e.message = r.format("dxDataGrid-exporting"), d(this.getDefaultOptions(), e);
  }
  show() {
    this._loadPanel.option("position", n.calculateLoadPanelPosition(this._$targetElement)), this._loadPanel.show();
  }
  dispose() {
    t(this._loadPanel.element()).remove(), delete this._loadPanel;
  }
}
export {
  m as E
};
//# sourceMappingURL=export_load_panel-C1_JdN4s.mjs.map
